import React, { Component } from 'react'

class PatentPublication extends Component {
    render(){
        return(
            <div className='w3-row w3-container'>
                <h4 className='w3-center'><b>Patent & Publications</b></h4>
                  <div className="w3-margin-bottom">
                        <table className="w3-table-all my-table"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Patent</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                
                                <td> Application No.</td>
                                <td> 201911002264</td>
                               
                            </tr>
                            <tr>
                                <td >Filing Date   </td>
                                <td>18/01/2019    </td>
                                
                            </tr>
                            <tr>
                                <td>Applicant     </td>
                                <td>Dayalbagh Educational Institute</td>
                                
                            </tr>
                            <tr>
                                <td>Title of the Invention        </td>
                                <td> Multiple land-use sun tracking  structure for accommodating solar panels.
</td>
                                
                            </tr>
                            
                         
                           

                    
                            </tbody>
                        </table>            

                        </div>

                        <div className="w3-margin-bottom">
                        <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading">Publications</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>“A Simplified and Effective GMPP Tracking Algorithm for Solar Photovoltaic System”, S. Agrawal, B. Tyagi, V. Kumar, P. Agarwal and P. Kumar, 51st NAPS, 13-15th October 2019, Wichita, Kansas, USA.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span> “Comparative Analysis of Metaheuristic Algorithms for the Implementation of Photovoltaic Solar Panel Model in MATLAB/Simulink”, Ashish Kumar, D. Bhagwan Das, Proceedings of National Systems Conference 2019, December 2019, IIT Roorkee.</td>
                               
                            </tr>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span> Real time performance of solar photovoltaic microgrid in India focusing on self-consumption in institutional buildings, K Pritam Satsangi, G S Sailesh babu, D Bhagwan Das, A KSaxena, Energy for sustainable development, 52, pp 40-51, 2019.</td>
                               
                            </tr>

                            

                           

                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>“Multi-agent Distributed Control and Power sharing between Microgrid DERs”, Y. Tripathy and B. Tyagi, National Power Systems Conference, 17-19th December 2020, IIT Gandhinagar, India.</td>
                                
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>“Self-Sustained Electric Farm Mini Harvester”, Murid Satsangi, Surat Swaroop Reddy, D. Bhagwan Das, International Conference on Innovative Engineering Design (ICoIED-2020), 18-19 January, 2020, Dehradun, India.</td>
                                
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>"3ph qZSI Controller Design using PI for DC side and PR for AC side Controller including Droop Characteristic in standalone mode", S. Agrawal, B. Tyagi, V. Kumar and P. Kumar, 2nd-5th January 2022, PESGRE2022, Thiruvananthapuram, India </td>
                                
                            </tr>
                         
                         
                           

                    
                            </tbody>
                        </table>            

                        </div>





            </div>

        )
    }
}

export default PatentPublication